import React from 'react'
import OrderList from './OrderList'
import Navbar from '../Navbar/Navbar'
import BottomNavbar from '../BottomNavbar/BottomNavbar'
export default function OrderContainer() {
  return (
    <>
    <Navbar/>
    <OrderList/>
    <BottomNavbar/>
    </>
  )
}
